import { BadgeLayoutProps } from 'framework/ui/uiContract';
import { ProjectReviewChangeType } from '../types';

export type ChangeTypeDisplay = {
  label: string;
  color: BadgeLayoutProps['color'];
};

export const ENTITY_BADGE_DISPLAY: Partial<Record<ProjectReviewChangeType, ChangeTypeDisplay>> = {
  CREATED: {
    label: 'Added',
    color: 'success',
  },
  DELETED: {
    label: 'Removed',
    color: 'error',
  },
  UPDATED: {
    label: 'Updated',
    color: 'primary',
  },
};
